export default __webpack_public_path__ + "static/media/newest-logo-updated-new.29e4d089.png";